import { render, staticRenderFns } from "./AddPhone.vue?vue&type=template&id=16a008cb&scoped=true&"
import script from "./AddPhone.vue?vue&type=script&lang=js&"
export * from "./AddPhone.vue?vue&type=script&lang=js&"
import style0 from "./AddPhone.vue?vue&type=style&index=0&id=16a008cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a008cb",
  null
  
)

export default component.exports